<template>
  <div id="ReconcileVue" class="xbig ybig" v-if="accountList != null">
    <vs-prompt name="reconcile" :vs-title="accountList[0].accountName + ' hesapları arası uzlaştırma'" vs-button-cancel="border" :vs-active="reconcilePopupProp" :vs-buttons-hidden="true"
      @vs-cancel="ReconcilePopupClosedChildEmit()"
      @vs-close="ReconcilePopupClosedChildEmit()"
      @vs-accept="ReconcilePopupClosedChildEmit()"
    
    >
      <div id="transactionDetail" name="transactionDetail" class="vx-row w-full ml-5 mr-2" style="margin-bottom: 15px;justify-content: center;margin-top: 15px;font-size: large;">
        <template v-if="reconcileItem.owedTransferAmount > 0 && reconcileItem.owedCurrencyId > 0 && reconcileItem.owedToTransferAmount > 0 && reconcileItem.owedToCurrencyId > 0 && reconcileItem.owedCurrencyId != reconcileItem.owedToCurrencyId">
          {{
            "İşlem Açıklaması :  " +
              accountList[0].accountName +
              " " +
              reconcileItem.owedCurrencyName +
              " hesabından " +
              reconcileItem.owedTransferAmount +
              " " +
              reconcileItem.owedCurrencyName +
              " para çıkışı yapılarak " +
              accountList[0].accountName +
              " " +
              reconcileItem.owedToCurrencyName +
              " hesabına " +
              reconcileItem.owedToTransferAmount +
              " " +
              reconcileItem.owedToCurrencyName +
              " para transferi yapılması. CustomerId : " +
              accountList[0].customerId +
              " : " +
              " Çapraz Kur " +
              reconcileItem.owedToTransferAmount / reconcileItem.owedTransferAmount 
              
          }}
        </template>
      </div>

      <div class="vx-row" style="justify-content: center;">
        <div class="vx-col ">
          <div style="width:100%">
            <div class="vx-row">
              <div class="vx-col  md:w-1/6 w-full" style="display:flex;height: min-content;">
                <label class="vs-input--label"> Döviz</label>
              </div>

              <div class="vx-col  md:w-1/3 w-full" style="display:flex;height: min-content;">
                <label class="vs-input--label"><strong> Bakiye</strong></label>
              </div>
            </div>
          </div>
          <div :key="i" v-for="(tr, i) in accountList" style="width:100%">
            <div class="vx-row">
              <div class="vx-col md:w-1/6 w-full" style="display:flex;height: min-content;">
                <vs-input readonly="readonly" class="w-full mt-4" v-model="tr.currencyName" type="text" name="ParaTur" />
              </div>

              <div class="vx-col md:w-1/3 w-full" style="display:flex;height: min-content;">
                <vs-input readonly="readonly" class="w-full mt-4" v-model="tr.balance" type="number" name="Bakiye" />
              </div>
              <div class="vx-col md:w-1/3 w-full mt-5" style="display:flex">
                <input
                  type="radio"
                  class="vs-radio "
                  v-model="reconcileItem.owedAccountId"
                  @change="
                    () => {
                      reconcileItem.owedTransferAmount = Math.abs(tr.balance);
                      reconcileItem.owedCurrencyId = tr.currencyId;
                      reconcileItem.owedCurrencyName = tr.currencyName;
                    }
                  "
                  :value="tr.accountId"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="vx-col ">
          <div style="width:100%">
            <div class="vx-row">
              <div class="vx-col  md:w-1/6 w-full" style="display:flex;height: min-content;">
                <label class="vs-input--label"> Döviz</label>
              </div>

              <div class="vx-col  md:w-1/3 w-full" style="display:flex;height: min-content;">
                <label class="vs-input--label"><strong> Bakiye</strong></label>
              </div>
            </div>
          </div>
          <div :key="i" v-for="(tr, i) in accountList" style="width:100%">
            <div class="vx-row">
              <div class="vx-col md:w-1/6 w-full" style="display:flex;height: min-content;">
                <vs-input readonly="readonly" class="w-full mt-4" v-model="tr.currencyName" type="text" name="ParaTur" />
              </div>

              <div class="vx-col md:w-1/3 w-full" style="display:flex;height: min-content;">
                <vs-input readonly="readonly" class="w-full mt-4" v-model="tr.balance" type="number" name="Bakiye" />
              </div>
              <div class="vx-col md:w-1/3 w-full mt-3" style="display:flex">
                <input
                  type="radio"
                  class="vs-radio "
                  v-model="reconcileItem.owedToAccountId"
                  @change="
                    () => {
                      reconcileItem.owedToTransferAmount = Math.abs(tr.balance);
                      reconcileItem.owedToCurrencyId = tr.currencyId;
                      reconcileItem.owedToCurrencyName = tr.currencyName;
                    }
                  "
                  :value="tr.accountId"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="vx-row w-full mt-5" style="justify-content: center;">
        <div class="vx-col md:w-1/24"></div>
        <div class="vx-col md:w-1/3">
          <label class="vs-input--label"> Borç Tutar</label>
          <vs-input class="w-full mt-4" v-model="reconcileItem.owedTransferAmount" type="number" name="Tutar" />
        </div>
        <div class="vx-col md:w-1/12">
          <label class="vs-input--label"> Borç Döviz</label>
          <vs-input readonly="readonly" class="w-full mt-4" v-model="reconcileItem.owedCurrencyName" name="Döviz" />
        </div>

        <div class="vx-col md:w-1/3">
          <label class="vs-input--label"> Alacak Tutar</label>
          <vs-input class="w-full mt-4" v-model="reconcileItem.owedToTransferAmount" type="number" name="Tutar" />
        </div>
        <div class="vx-col md:w-1/12">
          <label class="vs-input--label"> Alacak Döviz</label>
          <vs-input readonly="readonly" class="w-full mt-4" v-model="reconcileItem.owedToCurrencyName" name="Döviz" />
        </div>
      </div>

      <div class="vx-row w-full" style="justify-content:center">
        <vs-button
          class="mt-4"
          color="warning"
          @click="SaveReconcile()"
          v-if="reconcileItem.owedTransferAmount > 0 && reconcileItem.owedCurrencyId > 0 && reconcileItem.owedToTransferAmount > 0 && reconcileItem.owedToCurrencyId > 0 && reconcileItem.owedCurrencyId != reconcileItem.owedToCurrencyId"
          >Kaydet</vs-button
        >
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { repository } from "@/_services/repository.js";

export default {
  components: {
    vSelect,
  },
  props: {
    reconcilePopupProp: null,
    customerIdProp: null,
  },
  data() {
    return {
      productSearchPopupParent: false,
      moneyCurrencyOptions: [],
      accountList: null,
      owedAccountList: null,
      owedToAccountList: null,
      userList: [],
      reconcileItem: {
        owedCustomerId: null,
        owedToCustomerId: null,
        owedAccountType: null,
        owedAccountId: null,
        currencyId: null,
        fxRate: null,
        owedToAccountType: null,
        owedToAccountId: null,
        owedCurrencyId: null,
        owedToCurrencyId: null,
        owedToCurrencyFxRate: null,
        owedCurrencyFxRate: null,
        owedTransferAmount: null,
        owedToTransferAmount: null,
        transferFxRate: 1,
        transactionDescription: null,
        transactionDetail: null,
        transferTypeName: "Reconciliation",
      },

      customerSearchQuery: null,
      customerSearchQueryResult: [],
      currenttype: "",

      customerSearch: [],
      searchQuery: "",
      addNewCust: null,
      selectedCustomer: {},
      productSelection: [],
      imageList: [],
    };
  },
  computed: {},
  watch: {},
  methods: {
    ReconcilePopupClosedChildEmit: async function(item) {
      this.$emit("ReconcilePopupClosedChildEmit", item);
    },

    delayedSearch: async function() {
      if (this.delayedSearchTimer) {
        clearTimeout(this.delayedSearchTimer);
        this.delayedSearchTimer = null;
      }
      this.delayedSearchTimer = setTimeout(async () => {
        if (this.customerSearchQuery && this.customerSearchQuery.length > 2) {
          await this.CustomerSearch();
        }
      }, 500);
    },

    CustomerSearch: async function() {
      this.customerSearchQueryResult = await repository.getWithParam("Customer/search", "searchQuery=" + this.customerSearchQuery + "&pageSize=100").then((r) => r.list);

      console.log(this.customerSearchQueryResult);
    },



    SaveReconcile: async function() {
      this.reconcileItem.transactionDetail = document.getElementById("transactionDetail").innerText;

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz? Para transferi hemen gerçekleşecektir.",
        text: this.reconcileItem.transactionDetail,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.reconcileItem.transferFxRate = this.reconcileItem.owedToTransferAmount / this.reconcileItem.owedTransferAmount;
      this.reconcileItem.owedCurrencyFxRate = this.moneyCurrencyOptions.filter((r) => r.id == this.reconcileItem.owedCurrencyId).map((obj) => obj.value)[0];
      this.reconcileItem.owedToCurrencyFxRate = this.moneyCurrencyOptions.filter((r) => r.id == this.reconcileItem.owedToCurrencyId).map((obj) => obj.value)[0];

      this.$vs.loading();
      await repository.postEntity("Accounting/CreateMoneyTransfer", this.reconcileItem);
      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tamam",
        cancelButtonText: "Hayır",
      });

      this.reconcileItem = {
        owedCustomerId: null,
        owedToCustomerId: null,
        owedAccountType: null,
        owedAccountId: null,
        currencyId: null,
        fxRate: null,
        owedToAccountType: null,
        owedToAccountId: null,
        owedCurrencyId: null,
        owedToCurrencyId: null,
        owedToCurrencyFxRate: null,
        owedCurrencyFxRate: null,
        owedTransferAmount: null,
        owedToTransferAmount: null,
        transferFxRate: 1,
        transactionDescription: null,
        transactionDetail: null,
        transferTypeName: "Reconciliation",
      };
      this.ReconcilePopupClosedChildEmit();
    },

    getAccountList: async function() {
      let list = await repository.postEntity("Accounting/getAccount", { customerId: this.customerIdProp }).then((r) => r.list);

      if (this.customerIdProp > 0) {
        this.reconcileItem.owedAccountType = "Customer";
        this.reconcileItem.owedToAccountType = "Customer";
      }

      this.accountList = list;
      console.log(this.accountList);
    },
    getCurrencies: async function() {
      this.moneyCurrencyOptions = await repository.getAll("Accounting/getCurrencies").then((r) => r.list);
    },
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        this.ReconcilePopupClosedChildEmit();
      }
    });
  },
  created: async function() {
    await Promise.all([this.getAccountList(), this.getCurrencies()]);
  },
};
</script>

<style lang="scss" scoped>
.vs-dialog .vs-dialog-text {
  height: 99%;
  overflow-x: hidden;
  overflow-y: hidden;
}
</style>
